import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PropertyPaymentProviderService {
  getAll(organizationId: string, propertyId: string) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/payments/provider`,
      options,
    );
  }
}

export default PropertyPaymentProviderService;
